import React, { useCallback } from "react";
import {
  Typography,
  Button,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Grid,
} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import ProjectsTable from "../components/ProjectsTable";
import ProjectSearchBar from "../components/ProjectSearchBar";
import { CreateProjectModal } from "../components/modals/CreateProjectModal";
import { useSelector, useDispatch } from "react-redux";
import { updateProjectsSearchTerm } from "../reducers";
import ThemedTypography from "../components/ThemedTypography";
import ThemedIconButton from "../components/ThemedIconButton";

const ProjectsPage = () => {
  const darkThemeEnabled = useSelector((state) => state.darkThemeEnabled);
  const searchTerm = useSelector((state) => state.projects_search_term);
  const dispatch = useDispatch();
  const [open, setOpen] = React.useState(false);
  const employee = useSelector((state) => state.employee);
  
  const handleOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };

  const handleSearchChange = useCallback((searchValue) => {
    dispatch(updateProjectsSearchTerm(searchValue ?? ""));
  }, [dispatch]);

  return (
    <>
      <CreateProjectModal isOpen={open} handleClose={handleClose} />
      <div style={{ margin: "20px", paddingTop: "20px" }}>
        <ThemedTypography variant="h4" gutterBottom sx={{ fontWeight: "bold" }}>
          Projects
        </ThemedTypography>
        
        {/* Search Bar and Add New Button Row */}
        <Grid
          container
          alignItems="center"
          justifyContent="right"
          sx={{ marginBottom: "10px" }}
        >
          <Grid item sx={{ flex: 1, marginRight: "14px" }}>
            <ProjectSearchBar
              value={searchTerm}
              onSearchChange={handleSearchChange}
              placeholder="Search projects by name, account, project id, consultant, or cmas type..."
              isMobile={false}
            />
          </Grid>
          <Grid item>
            <ThemedIconButton onClick={handleOpen}>
              <AddIcon />
            </ThemedIconButton>
          </Grid>
        </Grid>
        <div style={{ height: "auto", width: "100%" }}>
          <ProjectsTable searchTerm={searchTerm} />
        </div>
      </div>
    </>
  );
};

export default ProjectsPage;
